<template>
  <v-card-text>
    <ul>
      <li>
        Starting as a classic (non-expansion) character is allowed.
      </li>
      <li>
        -w -sndbkg -3dfx are allowed.
      </li>
      <li>-act -ns -direct -txt -ns are banned.</li>
    </ul>
    <ul>
      <li>
        Using TCP/IP Host is allowed to reroll maps, but interacting with other
        characters in a TCP/IP game is banned.
      </li>
      <li>Joining a TCP/IP game or using Open Battle.net is banned.</li>
      <li>
        Hacks, mods or map revealing tools are banned. Use of Diablo Interface
        during a run is allowed.
      </li>
    </ul>
  </v-card-text>
</template>

<script>
export default {
  name: 'GeneralRules'
};
</script>
